var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    (_vm.page + "__card"),
    'card' ]},[_vm._t("default",function(){return [_vm._v("Page Content")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }